import { createAction, props } from '@ngrx/store';
import {
  Basket,
  BasketRowsGroupType,
} from 'graphql-api/baskets-api-interfaces';

export const selectBasketLine = createAction(
  '[Basket UI] Select Basket Items',
  props<{ basketItemIds: string[] }>(),
);
export const deselectBasketLine = createAction(
  '[Basket UI] Deselect Basket Items',
  props<{ basketItemIds: string[] }>(),
);
export const resetBasketItemsSelection = createAction(
  '[Basket UI] Reset Basket Items Selection',
);

export const initExpandDefaultBasketLines = createAction(
  '[Basket UI] Init Expand Default Basket Line',
  props<{ basketId: string }>(),
);
export const expandDefaultBasketLines = createAction(
  '[Basket UI] Expanded Default Basket Line',
);

export const expandAllBasketLines = createAction(
  '[Basket UI] Expand All Basket Lines',
);

export const expandBasketLines = createAction(
  '[Basket UI] Expand Basket Lines',
  props<{ ids: string[] }>(),
);
export const collapseBasketLines = createAction(
  '[Basket UI] Collapse Basket Lines',
  props<{ ids: string[] }>(),
);
export const resetExpandedLines = createAction(
  '[Basket UI] Reset expended lines',
);

export const groupDtoBasketSuccess = createAction(
  '[Basket] Group DTO Basket Success',
  props<{ groupedBaskets: { [key in BasketRowsGroupType]?: Basket } }>(),
);

export const groupDtoBasketFailure = createAction(
  '[Basket] Group DTO Basket Failure',
  props<{ error: string; basketId: string }>(),
);
